import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { UserEditModel } from 'src/app/models/user/user-edit.model';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { BasePage } from '../base-page';
import { createMask } from '@ngneat/input-mask';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'app-user-detail',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.scss'],
    standalone: false
})
export class UserDetatailComponent extends BasePage implements OnInit {

  public dateMask = createMask<string>({
    alias: 'datetime',
    inputFormat: 'dd.mm.yyyy',
    placeholder: '_',
    parser: (value: string) => this.prepareISODate(value),
  });

  public phoneMask = createMask<string>('+9 999 999 99 99');

  public userRoles: { [roleKey: string]: string }

  public model: UserEditModel = {
    id: '',
    name: '',
    role: '',
    userName: '',
    isEnabled: true
  };

  public constructor(private mUserService: UserService, private mApiService: ApiService, private mRouter: Router, activatedRoute: ActivatedRoute, private mMessageService: MessageService) {
    super();
    this.userRoles = mUserService.userRoles;

    if (!this.model.role) {
      this.model.role = this.getUserRoleKeys()[0];
    }

    this.model.id = activatedRoute.snapshot.params['id'] !== 'new' ? activatedRoute.snapshot.params['id'] : undefined;
  }

  ngOnInit(): void {
    this.isBusy = true;
    if (this.model.id) {
      this.mApiService.get<UserEditModel>(`/api/admin/user/manager/${this.model.id}`).subscribe({
        next: r => {
          this.model = r;
          if (this.model.birthDate) {
            this.model.birthDate = this.parseDate(this.model.birthDate);
          }

          this.isBusy = false;
        }, error: () => this.isBusy = false
      });
    } else {
      this.isBusy = false;
    }
  }

  public isSelf() {
    return new Observable<boolean>(obsr => {
      this.mUserService.getUser().subscribe(r => {
        if (!r) {
          obsr.next(false);
        } else {
          obsr.next(this.model.id == r.id);
        }
      });
    });
  }

  public save() {
    if (!this.model) {
      return;
    }

    this.isBusy = true;

    if (this.model.birthDate && this.needPrepareISODate(this.model.birthDate)) {
      this.model.birthDate = this.prepareISODate(this.model.birthDate);
    }

    if (!this.model.id) {
      this.mApiService.post<UserEditModel, UserEditModel>('/api/admin/user/manager', this.model).subscribe({
        next: r => {
          this.isBusy = false;

          this.mRouter.navigate([`/users/edit/${r.id}`]);

          this.mMessageService.addMessage({
            text: 'Пользователь сохранен',
            type: this.mMessageService.types.success
          }, true);
        }, error: () => this.isBusy = false
      });
    }
    else {
      this.mApiService.put<UserEditModel, UserEditModel>('/api/admin/user/manager', this.model).subscribe({
        next: r => {
          this.isBusy = false;

          this.model = r;
          if (this.model.birthDate) {
            this.model.birthDate = this.parseDate(this.model.birthDate);
          }

          this.mMessageService.addMessage({
            text: 'Пользователь сохранен',
            type: this.mMessageService.types.success
          }, true);

        }, error: () => this.isBusy = false
      });
    }
  }

  public isAdmin() {
    return this.model.role == this.userRoles['Admin'];
  }

  public getUserRoleKeys() {
    return Object.keys(this.userRoles);
  }

  private needPrepareISODate(value: string) {
    return value.indexOf('-') === -1;
  }

  private prepareISODate(value: string) {
    const date = value.split('.');
    const year = +date[2];
    const month = +date[1] - 1;
    const day = +date[0];

    const dateTime = new Date(Date.UTC(year, month, day, 0, 0));
    return dateTime.getUTCFullYear() + '-' + this.formatTime((dateTime.getUTCMonth() + 1)) + '-' + this.formatTime(dateTime.getUTCDate()) + 'T' + this.formatTime(dateTime.getUTCHours()) + ':' + this.formatTime(dateTime.getUTCMinutes()) + ':00.000';

  }

  private formatTime(input: number) {
    return input < 10 ? '0' + input : input;
  }

  private parseDate(date?: string) {
    if (!date) {
      return undefined;
    }

    const parts = date.split('T')[0].split('-')
    return this.formatTime(parseInt(parts[2], 10)) + '.' + this.formatTime(parseInt(parts[1], 10)) + '.' + parts[0]
  }
}
